import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Input, RadioGroup, SelectBox } from "@vertesia/ui/core";
import { useEffect, useState } from "react";
import { getFirebaseAuth } from "@vertesia/ui/session";
import { useUITranslation } from '../../i18n/index.js';
export default function SignupForm({ onSignup, goBack }) {
    const { t } = useUITranslation();
    const [accountType, setAccountType] = useState(undefined);
    const [companySize, setCompanySize] = useState(undefined);
    const [companyName, setCompanyName] = useState(undefined);
    const [companyWebsite, setCompanyWebsite] = useState(undefined);
    const [projectMaturity, setProjectMaturity] = useState(undefined);
    const [fbUser, setFbUser] = useState(undefined);
    const [error, setError] = useState(undefined);
    const isCompany = accountType === "company";
    const companySizeOptions = [
        { id: 1, label: t('signup.size1to10') },
        { id: 11, label: t('signup.size11to100') },
        { id: 101, label: t('signup.size101to1000') },
        { id: 1001, label: t('signup.size1001to5000') },
        { id: 5001, label: t('signup.size5000plus') },
    ];
    const accountTypeOptions = [
        {
            id: "personal",
            label: t('signup.personal'),
            description: t('signup.personalDescription'),
        },
        {
            id: "company",
            label: t('signup.company'),
            description: t('signup.companyDescription'),
        },
    ];
    const projectMaturityOptions = [
        { id: "testing", label: t('signup.justTesting') },
        { id: "exploring", label: t('signup.activelyExploring') },
        { id: "using", label: t('signup.alreadyUsing') },
        { id: "migrating", label: t('signup.migratingLLMs') },
        { id: "other", label: t('signup.other') },
    ];
    useEffect(() => {
        const user = getFirebaseAuth().currentUser;
        if (!user) {
            console.error('No user found');
            return;
        }
        setFbUser(user);
    }, [fbUser]);
    const isValid = () => {
        if (!accountType) {
            setError(t('signup.pleaseSelectAccountType'));
            return false;
        }
        if (isCompany && !companyName) {
            setError(t('signup.pleaseEnterOrgName'));
            return false;
        }
        if (isCompany && !companySize) {
            setError(t('signup.pleaseSelectCompanySize'));
            return false;
        }
        return true;
    };
    const onSubmit = async () => {
        if (!isValid())
            return;
        if (!accountType)
            return;
        const signupData = {
            accountType: accountType,
            companyName: companyName,
            companySize: companySize?.id,
            companyWebsite: companyWebsite,
            maturity: projectMaturity,
        };
        window.localStorage.setItem("composableSignupData", JSON.stringify(signupData));
        const fbToken = await getFirebaseAuth().currentUser?.getIdToken();
        console.log('Got firebase token', getFirebaseAuth(), fbToken);
        if (!fbToken) {
            console.error('No firebase token found');
            return;
        }
        onSignup(signupData, fbToken);
    };
    return (_jsxs("div", { className: "flex flex-col space-y-2", children: [_jsxs("div", { className: "prose", children: [_jsx("p", { className: "prose text-sm text-muted pt-4", children: t('signup.welcomeMessage', { name: fbUser?.displayName, email: fbUser?.email }) }), error &&
                        _jsx("div", { className: "text-destructive", children: error })] }), _jsx(FormItem, { label: t('signup.accountType'), children: _jsx(RadioGroup, { options: accountTypeOptions, selected: accountTypeOptions.find((option) => option.id === accountType), onSelect: (option) => setAccountType(option.id) }) }), isCompany &&
                _jsxs(_Fragment, { children: [_jsx(FormItem, { label: t('signup.companySize'), children: _jsx(SelectBox, { className: "w-full border border-accent bg-muted", value: companySize, options: companySizeOptions, onChange: setCompanySize, optionLabel: (option) => option?.label, placeholder: t('signup.selectCompanySize') }) }), _jsx(FormItem, { label: t('signup.companyName'), children: _jsx(Input, { value: companyName, onChange: setCompanyName, type: "text", required: true }) }), _jsx(FormItem, { label: t('signup.companyWebsite'), children: _jsx(Input, { value: companyWebsite, onChange: setCompanyWebsite, type: "text" }) })] }), _jsx(FormItem, { label: t('signup.projectMaturity'), children: _jsx(SelectBox, { className: "w-full border border-accent bg-muted", options: projectMaturityOptions, value: projectMaturityOptions.find((option) => option.id === projectMaturity), optionLabel: (option) => option?.label, placeholder: t('signup.selectProjectMaturity'), onChange: (option) => setProjectMaturity(option?.id) }) }), _jsxs("div", { className: "pt-8 flex flex-col", children: [_jsx(Button, { variant: "primary", onClick: onSubmit, size: "xl", children: _jsx("span", { className: "text-lg", children: t('signup.signUp') }) }), _jsx(Button, { variant: "ghost", size: "xl", className: "mt-4", onClick: goBack, children: _jsx("span", { className: "", children: t('signup.wrongAccountGoBack') }) })] })] }));
}
function FormItem({ label, children }) {
    return (_jsxs("div", { className: "flex flex-col space-y-2 pt-4", children: [_jsx("div", { className: "text-sm text-muted", children: label }), children] }));
}
//# sourceMappingURL=SignupForm.js.map